import React from "react";
import Pagination from "./Pagination";
import "./PaginationPannel.css";

const PaginationPannel = ({
  paginationPosition,
  paginationShadow = false,
  pagination,
  setOffset,
  offset,
  setLimit,
  limit,
  setGoto,
  goto,
  contentAfterTotalItems,
  dontShowActivePage,
  onClickOnPageNumber,
  disabled = false,
}) => {
  const pageniationContent = (
    <>
      {" "}
      <Pagination
        pagination={pagination}
        setOffset={setOffset}
        offset={offset}
        setLimit={setLimit}
        limit={limit}
        setGoto={setGoto}
        goto={goto}
        contentAfterTotalItems={contentAfterTotalItems}
        dontShowActivePage={dontShowActivePage}
        onClickOnPageNumber={onClickOnPageNumber}
        disabled={disabled}
      />{" "}
    </>
  );
  let content = "";
  if (paginationPosition.position === "center") {
    content = (
      <div className="pagination-in-center-layout">
        <div className="left-content" style={{paddingLeft:"10px"}}>{paginationPosition.leftContent}</div>
        <div className="middle-content">{pageniationContent}</div>
        <div className="right-content">{paginationPosition.rightContent}</div>
      </div>
    );
  } else if (paginationPosition.position === "left") {
    content = (
      <div className="pagination-in-onside-layout">
        <div className="left-content">{pageniationContent}</div>
        <div className="right-content">{paginationPosition.rightContent}</div>
      </div>
    );
  } else if (paginationPosition.position === "right") {
    content = (
      <div className="pagination-in-onside-layout">
        <div className="left-content">{paginationPosition.leftContent}</div>
        <div
          className="right-content"
          style={{ display: "grid", justifyContent: "flex-end" }}
        >
          {pageniationContent}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        boxShadow: paginationShadow
          ? "3px -6px 9px -3px rgba(0, 0, 0, 0.1)"
          : "",
      }}
    >
      {content}
    </div>
  );
};

export default PaginationPannel;
